import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The Salesforce connector can link accounts, contacts, leads, and other custom objects to PostHog.`}</p>
    <p>{`To link Salesforce:`}</p>
    <ol>
      <li parentName="ol">{`Go to the `}<a parentName="li" {...{
          "href": "https://us.posthog.com/pipeline/sources"
        }}>{`Data pipeline page`}</a>{` and the sources tab in PostHog`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Link Source`}</strong>{` and select Salesforce`}</li>
      <li parentName="ol">{`Log in to your Salesforce account and authorize PostHog to access your data`}</li>
      <li parentName="ol">{`Select the objects you want to sync (e.g., Accounts, Contacts, Leads)`}</li>
      <li parentName="ol"><em parentName="li">{`Optional:`}</em>{` Add a prefix to your table names`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Next`}</strong></li>
    </ol>
    <p>{`The data warehouse then starts syncing your Salesforce data. You can see details and progress in the `}<a parentName="p" {...{
        "href": "https://us.posthog.com/pipeline/sources"
      }}>{`data pipeline sources tab`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      